var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5544 10.8967C19.9494 10.7007 21.0234 9.50467 21.0264 8.05567C21.0264 6.62767 19.9854 5.44367 18.6204 5.21967",
    stroke: "#284184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3953 14.2503C21.7463 14.4523 22.6893 14.9253 22.6893 15.9003C22.6893 16.5713 22.2453 17.0073 21.5273 17.2813",
    stroke: "#284184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5535 14.6638C9.33948 14.6638 6.59448 15.1508 6.59448 17.0958C6.59448 19.0398 9.32248 19.5408 12.5535 19.5408C15.7675 19.5408 18.5115 19.0588 18.5115 17.1128C18.5115 15.1668 15.7845 14.6638 12.5535 14.6638Z",
    stroke: "#284184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5536 11.8879C14.6626 11.8879 16.3726 10.1789 16.3726 8.06888C16.3726 5.95988 14.6626 4.24988 12.5536 4.24988C10.4446 4.24988 8.73465 5.95988 8.73465 8.06888C8.72665 10.1709 10.4236 11.8809 12.5256 11.8879H12.5536Z",
    stroke: "#284184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55159 10.8967C5.15559 10.7007 4.08259 9.50467 4.07959 8.05567C4.07959 6.62767 5.12059 5.44367 6.48559 5.21967",
    stroke: "#284184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71075 14.2503C3.35975 14.4523 2.41675 14.9253 2.41675 15.9003C2.41675 16.5713 2.86075 17.0073 3.57875 17.2813",
    stroke: "#284184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.e47d28ebe12a16d3dfac4ff3e776b3d9.svg";
export { ForwardRef as ReactComponent };